import React, { Fragment } from "react";
import HeaderBotton from "../../../components/HeaderBottom";
import HeaderTop from "../../../components/HeaderTop";
import Breadcumb from "../../../components/Breadcumb";
import Service from "../../../components/Service";
import About from "../../../components/About";
import ServiceArea from "../../../components/ServiceArea";
import Testmonial from "../../../components/Testmonial";
import TeamMember from "../../../components/TeamMember";
import CounterArea from "../../../components/CounterArea";
import BlogArea from "../../../components/BlogArea";
import NewsLetter from "../../../components/Newsletter";
import FooterArea from "../../../components/FooterArea";
// images
import about from "../../../images/about/2.jpg";
import breadcumb from "../../../images/breadcumb/1.jpg";

import "./style.scss";

const aboutText = [
  {
    text: "Our practice is built around a broad range of legal disciplines, including commercial law, real estate and property matters, commercial and general litigation, personal injury claims, employment issues, family law, insolvency, business advisory work, and private immigration services. We are a leading English law firm that also delivers Sharia compliant solutions alongside our conventional legal offerings.",
  },
  {
    text: "We advise a wide spectrum of clients, from private individuals and families to emerging businesses, retail operators, private and listed companies, partnerships, asset management firms, hospitality groups, telecommunications providers, academic institutions, offshore entities, and diplomatic missions. Our client base also includes Middle Eastern royalty, well known figures in the beauty and commercial sectors, as well as charitable and nonprofit organizations.",
  },
  {
    text: "Established in 2020, the firm has expanded steadily, driven by the depth of experience within our team and the diversity of those we represent. What distinguishes us most is our team driven approach. We work closely with our clients, aligning our legal guidance with their objectives so that their interests remain central at every stage.",
  },
];

const services = [
  {
    icon: "flaticon-parents",
    title: "Family Law",
    content: "",
  },
  {
    icon: "flaticon-wounded",
    title: "Personal Injury",
    content: "",
  },
  {
    icon: "flaticon-employee",
    title: "Business Law",
    content: "",
  },
  {
    icon: "flaticon-thief",
    title: "Criminal Law",
    content: "",
  },
  {
    icon: "flaticon-university-graduate-hat",
    title: "Education Law",
    content: "",
  },
  {
    icon: "flaticon-house",
    title: "Real Estate Law",
    content: "",
  },
];

const breadcumbMenu = [{ name: "Home", route: "/" }, { name: "About us" }];

const AboutPage = () => {
  return (
    <Fragment>
      <header className="headerArea">
        <HeaderTop className="headerTop" />
        <HeaderBotton className="headerBottomArea headerBottomAreaStyelTwo" />
      </header>
      <Breadcumb
        className="breadcumbArea"
        title="About Us"
        breadcumbMenu={breadcumbMenu}
        background={
          "https://res.cloudinary.com/dndc0m3fq/image/upload/v1767210007/breakdownxx_nbkdps.jpg"
        }
      />
      <Service className="serviceArea mt-0" />
      <About
        className="aboutArea aboutAreaStyleTwo"
        title="Overview"
        subTitle=""
        noBtn={true}
        images={about}
        // orderLast="order-last"
        // videoId="XxVg_s8xAms"
        pragraphs={aboutText}
      />
      <ServiceArea
        className="ourServiceArea ourServiceAreaStyleTwo"
        title="How Can We Help You"
        subTitle="Area Of Practice"
        services={services}
      />
      <Testmonial className="testmonialArea pt100" />
      <CounterArea
        fullWidth={true}
        className="counterArea counterAreaStyleTwo"
      />
      <TeamMember
        title="Qualified Attorneys "
        subTitle="Meet Our Experts"
        className="teamArea"
        slider={true}
      />
      {/* <BlogArea
        className="blogArea"
        title="Latest News"
        subTitle="From Our Blog
                "
      /> */}
      <NewsLetter className="newsLetterArea" />
      <FooterArea />
    </Fragment>
  );
};
export default AboutPage;
